import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { map } from 'rxjs/operators';
import { AuthWatabilightService } from "./authWatabilight.service";
import {BookingService} from "./booking.service";
import {Observable} from "rxjs";
import {Yii} from "../../libraries/interfaces/Yii";

@Injectable()
export class IdentificateService {
    public authPath: string = `${sessionStorage.getItem("$instance_url")}api/watabilight/users/identificate`;

    constructor(
        protected readonly http: HttpClient,
    ) {
    }

    public identificate(url: string, booking: string, version: string): Observable<any> {

        const headers: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'cache-control': 'no-cache',
        });

        const body: any= {url};
        const options = { headers };

        return this.http.post(this.authPath, body, options);
    }


}